import { type FC, useContext } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import dibsCss from 'dibs-css';
import { Button } from 'dibs-elements/exports/Button.tsx';
import SellerFormContext from './SellerFormContext.tsx';

export const ConsignorsRestrictionMessage: FC = () => {
    const { dispatch } = useContext(SellerFormContext);

    return (
        <div className={classNames(dibsCss.flex, dibsCss.flexCol, dibsCss.gapMedium)}>
            <span data-tn="individual-application-message" className={dibsCss.sassyFontBody}>
                <FormattedMessage
                    id="SellerApplicationForm.ConsignorsRestrictionMessage.message1"
                    defaultMessage="Thank you for your interest in selling your items on 1stDibs. We sincerely appreciate your enthusiasm. At this time, our platform is exclusively open to professional sellers and galleries for selling merchandise. We understand this may be disappointing, and we value your understanding."
                />
            </span>
            <span className={dibsCss.sassyFontBody}>
                <FormattedMessage
                    id="SellerApplicationForm.ConsignorsRestrictionMessage.message2"
                    defaultMessage="Thank you again for considering 1stDibs, and we wish you success in your selling endeavors."
                />
            </span>
            <Button
                dataTn="individual-application-back-btn"
                fullWidth
                onClick={() => dispatch({ type: 'SET_STEP' })}
            >
                <FormattedMessage
                    id="SellerApplicationForm.ConsignorsRestrictionMessage.button"
                    defaultMessage="Back"
                />
            </Button>
        </div>
    );
};
